<lib-ph-bhp-manageelearning (childData)=onChildData($event) [isDesktop]=true></lib-ph-bhp-manageelearning>
 
